import { useStoreDetails } from './useStoreDetails'

export function useStoreAddresses() {
  const store = useStoreDetails()

  return store?.open_to_public_addresses?.filter((a) => a.open_to_public) ?? []
}
